var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 16.6667C18.659 16.6667 17.1667 18.159 17.1667 20V60C17.1667 61.841 18.659 63.3333 20.5 63.3333H60.5C62.341 63.3333 63.8333 61.841 63.8333 60V20C63.8333 18.159 62.341 16.6667 60.5 16.6667H20.5ZM10.5 20C10.5 14.4772 14.9772 10 20.5 10H60.5C66.0228 10 70.5 14.4772 70.5 20V60C70.5 65.5228 66.0228 70 60.5 70H20.5C14.9772 70 10.5 65.5228 10.5 60V20Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1666 10C29.0076 10 30.5 11.4924 30.5 13.3333V66.6667C30.5 68.5076 29.0076 70 27.1666 70C25.3257 70 23.8333 68.5076 23.8333 66.6667V13.3333C23.8333 11.4924 25.3257 10 27.1666 10Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8333 10C55.6743 10 57.1667 11.4924 57.1667 13.3333V66.6667C57.1667 68.5076 55.6743 70 53.8333 70C51.9924 70 50.5 68.5076 50.5 66.6667V13.3333C50.5 11.4924 51.9924 10 53.8333 10Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 26.6666C10.5 24.8256 11.9924 23.3333 13.8333 23.3333H27.1667C29.0076 23.3333 30.5 24.8256 30.5 26.6666C30.5 28.5075 29.0076 29.9999 27.1667 29.9999H13.8333C11.9924 29.9999 10.5 28.5075 10.5 26.6666Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 53.3333C10.5 51.4924 11.9924 50 13.8333 50H27.1667C29.0076 50 30.5 51.4924 30.5 53.3333C30.5 55.1743 29.0076 56.6667 27.1667 56.6667H13.8333C11.9924 56.6667 10.5 55.1743 10.5 53.3333Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 40.0001C10.5 38.1591 11.9924 36.6667 13.8333 36.6667H67.1667C69.0076 36.6667 70.5 38.1591 70.5 40.0001C70.5 41.841 69.0076 43.3334 67.1667 43.3334H13.8333C11.9924 43.3334 10.5 41.841 10.5 40.0001Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 26.6666C50.5 24.8256 51.9924 23.3333 53.8333 23.3333H67.1667C69.0076 23.3333 70.5 24.8256 70.5 26.6666C70.5 28.5075 69.0076 29.9999 67.1667 29.9999H53.8333C51.9924 29.9999 50.5 28.5075 50.5 26.6666Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 53.3333C50.5 51.4924 51.9924 50 53.8333 50H67.1667C69.0076 50 70.5 51.4924 70.5 53.3333C70.5 55.1743 69.0076 56.6667 67.1667 56.6667H53.8333C51.9924 56.6667 50.5 55.1743 50.5 53.3333Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.47457f36037d4c368df92e2cabfe3395.svg";
export { ForwardRef as ReactComponent };